import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxPaginationModule } from 'ngx-pagination';
import { EmployeeListRoutingModule } from './employee-list-routing.module';

import { EmployeeListComponent } from './employee-list.component';
import { TopNavigationModule } from '../../components/top-navigation/top-navigation.module';
import { SearchCollaboratorModule } from '../../components/search-collaborator/search-collaborator.module';
import { FeatureListFiltersModule } from '@unico-people/shared/dashboard/feature-list-filters';
import { FeaturePaginationModule } from '@unico-people/shared/dashboard/feature-pagination';
import { MatDialogModule } from '@angular/material/dialog';
import { FeatureStatusErrorModule } from '@unico-people/shared/dashboard/feature-status-error';

import { ItemCollaboratorModule } from '../../components/item-collaborator/item-collaborator.module';

@NgModule({
  declarations: [EmployeeListComponent],
  imports: [
    CommonModule,
    NgxPaginationModule,
    EmployeeListRoutingModule,
    TopNavigationModule,
    SearchCollaboratorModule,
    FeatureListFiltersModule,
    ItemCollaboratorModule,
    FeaturePaginationModule,
    MatDialogModule,
    FeatureStatusErrorModule
   ]
})
export class EmployeeListModule {}
